import { action } from "mobx";
import previewService from "~/services/PreviewService";

export class PreviewStore {
  @action.bound
  add = async (preview) => {
    return await previewService.add(preview);
  }; 
}

const previewStore = new PreviewStore();
export default previewStore;
